module.exports = __webpack_public_path__ + "img/frame (252).a7f53080.jpg";